import React from 'react'

import TotalPrice from 'modules/Checkout/TotalPrice'
import priceParser from 'utils/priceParser'

const tmpPrice = 4242.42

const SummaryItem = ({t}) => (
  <div>
    <span><b>1x</b> Hamilton Perfection Roller Hamilton Perfection Roller Hamilton Perfection Roller</span>
    <i>{t('Category')} <b>Building material</b></i>
    <b>{priceParser(tmpPrice)}</b>
  </div>
)

const SideSummary = ({t}) => (
  <div>
    <h6>{t('Summary')}</h6>

    <div className='checkout2-summaryItems'>
      <SummaryItem t={t}/>
      <SummaryItem t={t}/>
      <SummaryItem t={t}/>
    </div>

    <TotalPrice t={t}/>
  </div>
)

export default SideSummary
